import { getApiClient } from './AxiosService'

async function getPovratProizvodaService(data) {
  try {
    const result = await getApiClient(data.accessToken).get('povrat-proizvodi')
    if (result.status === 200 && result.data && result.data.code === 200) {
      return {
        isOk: true,
        data: result.data.data,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    return {
      isOk: false,
      status: error.response?.status,
      message: error.message,
    }
  }
}

async function createPovratProizvodaService(data) {
  try {
    const result = await getApiClient(data.accessToken).post(
      'povrat-proizvodi',
      data,
    )
    if (result.status === 201 && result.data && result.data.code === 201) {
      return {
        isOk: true,
        data: result.data.data,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function updatePovratProizvodaService(data) {
  try {
    const result = await getApiClient(data.accessToken).put(
      `povrat-proizvodi/${data.id}`,
      data,
    )
    if (result.status === 200 && result.data && result.data.code === 200) {
      return {
        isOk: true,
        data: result.data.data,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

async function deletePovratProizvodaService(data) {
  try {
    const result = await getApiClient(data.accessToken).delete(
      `povrat-proizvodi/${data.id}`,
    )
    if (result.status === 200 && result.data && result.data.success) {
      return {
        isOk: true,
      }
    } else {
      return {
        isOk: false,
      }
    }
  } catch (error) {
    return {
      isOk: false,
      message: error.message,
    }
  }
}

export {
  getPovratProizvodaService,
  createPovratProizvodaService,
  updatePovratProizvodaService,
  deletePovratProizvodaService,
}
